var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('BasicVideoPicsTextSwiper',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"imgs":_vm.imgs,"id":"11"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }